<script lang="ts">
	import type { HRTPoiData } from '../card/factories-utils';
	import { page } from '$app/state';
	import { trackPoiListBookEvent } from '$lib/services/tracking/googleAnalytics/pois';
	import { buildPoiCardPropsForSummaryCardAndMarkerPopup } from '../card/factories-utils';
	import PoiCard from '../card/PoiCard.svelte';
	import { type AccommodationMichelinPoiData, type AccommodationPoiData, type RestaurantMichelinPoiData, type RestaurantPoiData, type SummaryPoiData, type TourismPoiData } from '../types';
	import { isHRTPoi } from '../utils';
	import GasStationPoiSummary from './gasStation/GasStationPoiSummary.svelte';
	import ParkingPoiSummary from './parking/ParkingPoiSummary.svelte';

	type PoiDataWithImages = AccommodationPoiData | AccommodationMichelinPoiData | RestaurantPoiData | RestaurantMichelinPoiData | TourismPoiData | HRTPoiData;

	interface Props {
		poiData: SummaryPoiData | HRTPoiData;
		onAddClick: () => void;
		onAddItineraryClick: (poi: HRTPoiData) => void;
		onCardClick: (e: MouseEvent) => void;
	}

	const { poiData, onAddClick, onAddItineraryClick, onCardClick }: Props = $props();

	function handleBookClick(poi: SummaryPoiData | HRTPoiData) {
		trackPoiListBookEvent(poi, 'poimap_book');
	}
</script>

{#if poiData.__typename === 'ParkingPOI'}
	<ParkingPoiSummary
		name={poiData.name}
		address={poiData.splittedAddress}
		bookUrl={poiData.redirectUrl}
		onBookClick={() => handleBookClick(poiData)}
		{onAddClick}
	/>
{:else if poiData.__typename === 'ServiceGasStationPOI'}
	<GasStationPoiSummary
		name={poiData.name}
		fuelPrices={poiData.fuels?.prices}
		lastUpdated={poiData.fuels?.lastUpdatedAt ? new Date(poiData.fuels?.lastUpdatedAt) : undefined}
		{onAddClick}
	/>
{:else if isHRTPoi(poiData)}
	{@const poiDataWithOneImages = (poiData as PoiDataWithImages)?.images?.length > 1 ? { ...poiData, images: [(poiData as PoiDataWithImages).images[0]] } : poiData}
	<PoiCard
		cardProps={buildPoiCardPropsForSummaryCardAndMarkerPopup(poiDataWithOneImages, page, undefined, { hero: { class: 'no-hover' }, classes: 'no-hover' })}
		{onCardClick}
		onAddItineraryClick={() => onAddItineraryClick(poiDataWithOneImages as HRTPoiData)}
		onBookClick={() => handleBookClick(poiDataWithOneImages)}
		isHovered={false}
		layout="horizontal"
	/>
{/if}
